import axios, { AxiosResponse } from 'axios';
import { API_BASE_URL } from '../config';

export async function fetchDepartments() {
    return await axios({
        baseURL: API_BASE_URL,
        method: 'get',
        url: '/common/departments',
    });
}

export async function fetchDoctors(departmentId) {
  const url = departmentId
    ? `/common/doctors?departmentId=${departmentId}`
    : '/common/doctors';

  return await axios({
    baseURL: API_BASE_URL,
    method: 'get',
    url,
  });
}

export async function createContact(data) {
    return await axios({
        baseURL: API_BASE_URL,
        method: 'post',
        data: data,
        url: '/contactUs/createContact',
    });
}

export async function createAppointment(data) {
    return await axios({
        baseURL: API_BASE_URL,
        method: 'post',
        data: data,
        url: '/appointment-booking/createAppointment',
    });
}

export async function createSubscription(data) {
    return await axios({
        baseURL: API_BASE_URL,
        method: 'post',
        data: data,
        url: '/auth/subscribe',
    });
}